import { listItemIconClasses } from '@mui/material/ListItemIcon';
import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiMenuItem = {
  defaultProps: { disableRipple: true },
  styleOverrides: {
    root: {
      borderRadius: '10px',
      gap: '10px',
      minHeight: '34px',
      paddingBlock: 'var(--MenuItem-paddingBlock, 6px)',
      paddingInline: 'var(--MenuItem-paddingInline, 10px)',
      [`& .${listItemIconClasses.root}`]: { minWidth: 'auto' },
    },
  },
} satisfies Components<Theme>['MuiMenuItem'];
